/**
 * Generated by scripts/generate-drizzle-schema.mjs. Do not edit by hand.
 * This product's inputs: scripts/drizzle-schema.config.mjs.
 * Regenerate: bash scripts/client-schema-fresh.sh (data-model-change skill).
 */

import { DrizzleAppSchema, type PowerSyncSQLiteDatabase } from "@powersync/drizzle-driver";
import { index, integer, sqliteTable, text } from "drizzle-orm/sqlite-core";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";

export const activity_recent = sqliteTable(
  "activity_recent",
  {
    id: text("id").primaryKey(),
    scope_id: text("scope_id"),
    list_id: text("list_id"),
    entity_type: text("entity_type"),
    entity_id: text("entity_id"),
    action: text("action"),
    actor_user_id: text("actor_user_id"),
    actor_name: text("actor_name"),
    actor_device_id: text("actor_device_id"),
    platform: text("platform"),
    server_ts: text("server_ts"),
    client_ts: text("client_ts"),
    patch: text("patch"),
    batch_id: text("batch_id"),
    reverts_activity_id: text("reverts_activity_id"),
  },
  (table) => [
    /** ORDER BY server_ts DESC in activity feed */
    index("activity_recent_by_feed").on(table.server_ts),
    /** WHERE entity_type = ? AND entity_id = ? in entity history */
    index("activity_recent_by_entity").on(table.entity_type, table.entity_id, table.server_ts),
  ],
);

export const attachment = sqliteTable(
  "attachment",
  {
    id: text("id").primaryKey(),
    todo_id: text("todo_id"),
    filename: text("filename"),
    content_type: text("content_type"),
    size: integer("size"),
    url: text("url"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    list_id: text("list_id"),
    user_id: text("user_id"),
    is_shared: integer("is_shared"),
    hash: text("hash"),
  },
  (table) => [
    /** WHERE todo_id = ? ORDER BY created_at in useAttachments */
    index("attachment_by_todo").on(table.todo_id, table.created_at),
    /** WHERE user_id = ? in getHasLocalDataQuery */
    index("attachment_by_user").on(table.user_id),
  ],
);

export const font_family = sqliteTable("font_family", {
  id: text("id").primaryKey(),
  family: text("family"),
  name: text("name"),
  category: text("category"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const font_variant = sqliteTable("font_variant", {
  id: text("id").primaryKey(),
  font_family_id: text("font_family_id"),
  weight: text("weight"),
  url: text("url"),
  created_at: text("created_at"),
  attachment_id: text("attachment_id"),
});

// ⚡ Table with index on user_id to speed up getHasLocalDataQuery.
export const list = sqliteTable(
  "list",
  {
    id: text("id").primaryKey(),
    name: text("name"),
    color: text("color"),
    icon: text("icon"),
    user_id: text("user_id"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    theme_id: text("theme_id"),
    is_blur: integer("is_blur"),
    is_shared: integer("is_shared"),
    group_id: text("group_id"),
    follow_device_theme: integer("follow_device_theme"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE user_id = ? in useLists and getHasLocalDataQuery */
    index("list_by_user").on(table.user_id),
  ],
);

// ⚡ Table with index on user_id to speed up getHasLocalDataQuery.
export const list_group = sqliteTable(
  "list_group",
  {
    id: text("id").primaryKey(),
    name: text("name"),
    user_id: text("user_id"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    color: text("color"),
    icon: text("icon"),
  },
  (table) => [
    /** WHERE user_id = ? in useListGroups and getHasLocalDataQuery */
    index("list_group_by_user").on(table.user_id),
  ],
);

export const list_group_item = sqliteTable(
  "list_group_item",
  {
    id: text("id").primaryKey(),
    list_id: text("list_id"),
    group_id: text("group_id"),
    added_at: text("added_at"),
    user_id: text("user_id"),
  },
  (table) => [
    /** LEFT JOIN list_group_item ON list.id = list_group_item.list_id in useLists() */
    index("list_group_item_by_list").on(table.list_id),
    /** WHERE group_id = ? ORDER BY added_at DESC in useGroupItems() */
    index("list_group_item_by_group").on(table.group_id, table.added_at),
  ],
);

// Dataset managed by sync streams — indexes not needed for now.
export const list_organization = sqliteTable("list_organization", {
  id: text("id").primaryKey(),
  list_id: text("list_id"),
  organization_id: text("organization_id"),
  added_at: text("added_at"),
  added_by: text("added_by"),
});

// Small dataset per user — indexes not needed for now.
export const member = sqliteTable("member", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  user_id: text("user_id"),
  role: text("role"),
  created_at: text("created_at"),
});

// Small dataset — indexes not needed for now.
export const organization = sqliteTable("organization", {
  id: text("id").primaryKey(),
  name: text("name"),
  slug: text("slug"),
  logo: text("logo"),
  metadata: text("metadata"),
  created_at: text("created_at"),
});

export const saved_view = sqliteTable("saved_view", {
  id: text("id").primaryKey(),
  user_id: text("user_id"),
  name: text("name"),
  icon: text("icon"),
  color: text("color"),
  filters: text("filters"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

// Active user sessions — small dataset, no indexes.
export const session = sqliteTable("session", {
  id: text("id").primaryKey(),
});

export const subtask = sqliteTable(
  "subtask",
  {
    id: text("id").primaryKey(),
    todo_id: text("todo_id"),
    text: text("text"),
    completed: integer("completed"),
    order: integer("order"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    list_id: text("list_id"),
    user_id: text("user_id"),
    is_shared: integer("is_shared"),
  },
  (table) => [
    /** WHERE todo_id = ? ORDER BY order, created_at in useSubtasks() */
    index("subtask_by_todo").on(table.todo_id, table.order, table.created_at),
    /** WHERE user_id = ? in getHasLocalDataQuery */
    index("subtask_by_user").on(table.user_id),
  ],
);

// Small global dataset (~20 themes) — indexes not needed.
export const themes = sqliteTable("themes", {
  id: text("id").primaryKey(),
  name: text("name"),
  background: text("background"),
  surface: text("surface"),
  accent: text("accent"),
  glow_colors: text("glow_colors"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  is_dark: integer("is_dark"),
  foreground: text("foreground"),
  field_background: text("field_background"),
  danger: text("danger"),
  success: text("success"),
  warning: text("warning"),
  muted: text("muted"),
  pattern_type: text("pattern_type"),
  pattern_opacity: integer("pattern_opacity"),
  pair_id: text("pair_id"),
  font_normal: text("font_normal"),
  font_medium: text("font_medium"),
  font_semibold: text("font_semibold"),
  font_bold: text("font_bold"),
  radius: text("radius"),
  surface_foreground: text("surface_foreground"),
  surface_secondary: text("surface_secondary"),
  surface_secondary_foreground: text("surface_secondary_foreground"),
  surface_tertiary: text("surface_tertiary"),
  surface_tertiary_foreground: text("surface_tertiary_foreground"),
  overlay: text("overlay"),
  overlay_foreground: text("overlay_foreground"),
  default: text("default"),
  default_foreground: text("default_foreground"),
  accent_foreground: text("accent_foreground"),
  field_foreground: text("field_foreground"),
  field_placeholder: text("field_placeholder"),
  field_border: text("field_border"),
  danger_foreground: text("danger_foreground"),
  success_foreground: text("success_foreground"),
  warning_foreground: text("warning_foreground"),
  segment: text("segment"),
  segment_foreground: text("segment_foreground"),
  border: text("border"),
  focus: text("focus"),
  link: text("link"),
  surface_shadow: text("surface_shadow"),
  overlay_shadow: text("overlay_shadow"),
  field_shadow: text("field_shadow"),
  muted_foreground: text("muted_foreground"),
  divider: text("divider"),
  glass_background: text("glass_background"),
  glass_border: text("glass_border"),
  glass_highlight: text("glass_highlight"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
});

// ⚡ Largest table (~4500+ rows). Indexes here have the greatest impact.
export const todo = sqliteTable(
  "todo",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    text: text("text"),
    completed: integer("completed"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    list_id: text("list_id"),
    important: integer("important"),
    note: text("note"),
    due_date: text("due_date"),
    recurrence_rule: text("recurrence_rule"),
    my_day_date: text("my_day_date"),
    reminder_at: text("reminder_at"),
    is_shared: integer("is_shared"),
    deleted_at: text("deleted_at"),
    assigned_to: text("assigned_to"),
  },
  (table) => [
    /** JOIN todo ON list.id = todo.list_id in useLists() */
    index("todo_by_list").on(table.list_id, table.completed, table.updated_at),
    /** WHERE user_id = ? in global aggregation queries */
    index("todo_by_user").on(table.user_id, table.completed, table.important),
    /** WHERE user_id = ? AND my_day_date IS NOT NULL AND my_day_date <= ? ORDER BY updated_at DESC in useMyDay() */
    index("todo_by_my_day").on(table.user_id, table.my_day_date, table.updated_at),
    /** WHERE due_date IS NOT NULL ORDER BY completed ASC, updated_at DESC in useTodos({ plannedOnly }) */
    index("todo_by_due_date").on(table.due_date, table.completed, table.updated_at),
    /** WHERE important = 1 ORDER BY completed ASC, updated_at DESC in useTodos({ importantOnly }) */
    index("todo_by_important").on(table.important, table.completed, table.updated_at),
    /** ORDER BY completed ASC, updated_at DESC in useTodos({ filter: 'all' }) */
    index("todo_by_global_sort").on(table.completed, table.updated_at),
    /** WHERE completed = 0 AND due_date > datetime('now') ORDER BY due_date ASC */
    index("todo_by_reminders").on(table.completed, table.due_date),
  ],
);

// Only 1 row per user — indexes not needed.
export const user = sqliteTable("user", {
  id: text("id").primaryKey(),
  name: text("name"),
  email: text("email"),
  email_verified: integer("email_verified"),
  image: text("image"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  locale: text("locale"),
  global_theme_id: text("global_theme_id"),
  is_blur: integer("is_blur"),
  font_family: text("font_family"),
  follow_device_theme: integer("follow_device_theme"),
  role: text("role"),
});

export const drizzleSchema = {
  activity_recent,
  attachment,
  font_family,
  font_variant,
  list,
  list_group,
  list_group_item,
  list_organization,
  member,
  organization,
  saved_view,
  session,
  subtask,
  themes,
  todo,
  user,
};

export const AppSchema = new DrizzleAppSchema(drizzleSchema);

export type Database = (typeof AppSchema)["types"];

/**
 * Type helper for the Drizzle database instance wrapped with PowerSync.
 */
export type PowerSyncDrizzleDB = PowerSyncSQLiteDatabase<typeof drizzleSchema>;

export const USER_DATA_TABLES = [
  "attachment",
  "list",
  "list_group",
  "list_group_item",
  "saved_view",
  "subtask",
  "todo",
] as const;

export type ActivityRecent = InferSelectModel<typeof activity_recent>;
export type ActivityRecentInsert = InferInsertModel<typeof activity_recent>;
export type ActivityRecentRecord = ActivityRecent;
export type Attachment = InferSelectModel<typeof attachment>;
export type AttachmentInsert = InferInsertModel<typeof attachment>;
export type AttachmentRecord = Attachment;
export type FontFamily = InferSelectModel<typeof font_family>;
export type FontFamilyInsert = InferInsertModel<typeof font_family>;
export type FontFamilyRecord = FontFamily;
export type FontVariant = InferSelectModel<typeof font_variant>;
export type FontVariantInsert = InferInsertModel<typeof font_variant>;
export type FontVariantRecord = FontVariant;
export type List = InferSelectModel<typeof list>;
export type ListInsert = InferInsertModel<typeof list>;
export type ListRecord = List;
export type ListGroup = InferSelectModel<typeof list_group>;
export type ListGroupInsert = InferInsertModel<typeof list_group>;
export type ListGroupRecord = ListGroup;
export type ListGroupItem = InferSelectModel<typeof list_group_item>;
export type ListGroupItemInsert = InferInsertModel<typeof list_group_item>;
export type ListGroupItemRecord = ListGroupItem;
export type ListOrganization = InferSelectModel<typeof list_organization>;
export type ListOrganizationInsert = InferInsertModel<typeof list_organization>;
export type ListOrganizationRecord = ListOrganization;
export type Member = InferSelectModel<typeof member>;
export type MemberInsert = InferInsertModel<typeof member>;
export type MemberRecord = Member;
export type Organization = InferSelectModel<typeof organization>;
export type OrganizationInsert = InferInsertModel<typeof organization>;
export type OrganizationRecord = Organization;
export type SavedView = InferSelectModel<typeof saved_view>;
export type SavedViewInsert = InferInsertModel<typeof saved_view>;
export type SavedViewRecord = SavedView;
export type Session = InferSelectModel<typeof session>;
export type SessionInsert = InferInsertModel<typeof session>;
export type SessionRecord = Session;
export type Subtask = InferSelectModel<typeof subtask>;
export type SubtaskInsert = InferInsertModel<typeof subtask>;
export type SubtaskRecord = Subtask;
export type Themes = InferSelectModel<typeof themes>;
export type ThemesInsert = InferInsertModel<typeof themes>;
export type ThemesRecord = Themes;
export type Todo = InferSelectModel<typeof todo>;
export type TodoInsert = InferInsertModel<typeof todo>;
export type TodoRecord = Todo;
export type User = InferSelectModel<typeof user>;
export type UserInsert = InferInsertModel<typeof user>;
export type UserRecord = User;
